import { createTranslationObject } from '../helper';
import { Locale } from 'chaika-enums';
export const ptTranslations = createTranslationObject(Locale.Pt);
